import React from "react";
import ReporteVentas from "../components/pages/ReporteVentas"
import ProfileUsers from "../components/pages/Admin/ProfileUsers"
import Perfil from "../components/pages/Perfil";
/* import Form from "../components/globals/FormNativ"; */


export const getAccionOption = (option,collapsed) =>{

  let response = {};
  switch (option) {
   
    case 'Ventas':
      response.content = <ReporteVentas collapsed={collapsed}/>;
      break;
    case 'admin_users_profile':
      response.content = <ProfileUsers collapsed={collapsed}/>;
      break;
    case 'logout':
      response.accion = 'logout';
      break;
    case 'perfil':
      response.content = <Perfil/>
    break;
    default:
      response.accion = 'nada';
      break;
  }
  
  return response;
};
